/**
    热卖商品
**/
<template>
  <div class="leftaside">
    <h4>{{navTitle}}</h4>
    <ul class="left_product">
      <li v-for="(item,index) in hotGoodsList.slice(0,10)" :key="index">
        <div class="p-img">
          <!-- 商城 -->
          <router-link
            v-if="supplieStore==0?true:false"
            class="item_link"
            :to="`/goodsdetail?id=${item.id}`"
            @click.native="$router.go(0)"
          >
            <el-image class="img-responsive" :src="`${item.photos}`" style="display: block" >
                 <div slot="error" class="image-slot">
                   <i class="el-icon-picture-outline"></i>
                 </div>
            </el-image>
          </router-link>
          <!-- 批发市场 -->
          <router-link
          v-if="supplieStore"
            class="item_link"
            :to="`/goodsDetail_supplie?id=${item.id}`"
            @click.native="$router.go(0)"
          >
            <el-image class="img-responsive" :src="`${item.photos}`" style="display: block" >
                 <div slot="error" class="image-slot">
                   <i class="el-icon-picture-outline"></i>
                 </div>
            </el-image>
          </router-link>
        </div>
        <div class="pro-price">
          <!-- <strong><em>¥</em><i>{{(item.price!=null && item.price!="")?item.price: item.marketprice}}</i></strong> -->
          <strong><em>¥</em><i>{{item.realprice!=-1?item.realprice:'面议'}}</i></strong>
        </div>
        <div class="pro_name">
           <!-- 商城 -->
          <router-link v-if="supplieStore==0?true:false" :to="`/goodsdetail?id=${item.id}`" @click.native="$router.go(0)">{{item.name}}</router-link>
          <!-- 批发市场 -->
          <router-link v-if="supplieStore" :to="`/goodsDetail_supplie?id=${item.id}`" @click.native="$router.go(0)">{{item.name}}</router-link>
        </div>
      </li>
      <li>
          <div class="nodate" v-if="hotGoodsList.length==0?true:false">
            <div class="first">暂无热销商品</div>
          </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
 props: ['navTitle','hotGoodsList','supplieStore'],
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  },
};
</script>

<style scoped>
.leftaside {
  width:"200px";
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro-price {
  margin: 10px 0;
  color: #e4393c;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
}
.img-responsive {
  /* width: 100%; */
  width: 160px;
  height: 160px;
}

.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/components/hotGoods.vue